import { AbstractTicketProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTicketProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { GraphicsProperties } from "../display/TitanGraphics";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
/**
 * GameTicketProperties.ts
 */
export class GameTicketProperties extends AbstractTicketProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundSize.equals(other.backgroundSize);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.slingoInitialDelay = 300;
        this.patternWinInterval = 500;
        this.symbolPanelProperties = new PanelProperties();
        this.symbolPanelProperties.layout = new GridLayout(5, 5, 173.5, 173.5);
        this.mouseBlockerProperties = new MouseBlockerProperties(0x001842, 0.4);
        this.reelAreaProperties = new GraphicsProperties();
    }
}
//# sourceMappingURL=GameTicketProperties.js.map